<template>
  <div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">域名状态：</div>
          <div class="bj-rows">
            <div :class="['item-radio',{ active: item.value === searchObj.status }]"
              v-for="item in domainStatusList"
              :key="item.value"
              @click="onCheckDomainStatus(item.value)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px;">
        <div class="item">
          <div class="name" style="margin-right: 10px">域名：</div>
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="domainName"
            placeholder="请输入搜索的域名名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item" style="margin-left: 20px;">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="bj-border-F85A36" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">收到的请求<span class="count">（{{ searchObj.total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="status" slot-scope="{ row }">
          {{ row.status | statusFilter }}
        </template>
        <template slot="result" slot-scope="{ row }">
          <div
            style="color: #2d8cf0; cursor: pointer"
            @click="onShowDomainList(row.resultList)"
          >
            {{ row.res }}
          </div>
        </template>
        <template slot="remark" slot-scope="{ row }">
          <div class="table-btn" @click="onShowRemark(row.remark)">查看</div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div v-if="row.status === 0" class="table-btn" @click="onReject(row)">取消</div>
          <div v-else>--</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
    <!-- PUSH备注 -->
    <pushRemarkModal
      :show.sync="pushRemarkModalVisibility"
      :data="remark"
    ></pushRemarkModal>
    <!-- PUSH结果 -->
    <pushResultModal
      :show.sync="pushResultModalVisibility"
      :data="resultList"
    ></pushResultModal>
  </div>
</template>

<script>
import { pushPageList, pushEdit } from "api/domain.js";
import pushRemarkModal from "components/push/pushRemarkModal.vue";
import pushResultModal from "components/push/pushResultModal.vue";

export default {
  name: "pushSent",
  components: {
    pushRemarkModal,
    pushResultModal,
  },
  filters: {
    statusFilter(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未接收";
          break;
        case 1:
          title = "已接收";
          break;
        case 2:
          title = "已拒绝";
          break;
        case 3:
          title = "对方取消";
          break;
        case 4:
          title = "未接收";
          break;
        default:
          break;
      }
      return title;
    },
  },
  data() {
    return {
      domainName: "",
      // 域名状态
      domainStatusList: [
        {
          name: "全部域名",
          value: -1,
        },
        {
          name: "未接收",
          value: 0,
        },
        {
          name: "已接收",
          value: 1,
        },
        {
          name: "已拒绝",
          value: 2,
        },
        {
          name: "对方取消",
          value: 3,
        },
      ],
      columns: [
        {
          title: "域名",
          align: "center",
          key: "ym",
        },
        {
          title: "对方ID",
          align: "center",
          key: "recipient",
        },
        {
          title: "成功/失败/总数",
          align: "center",
          slot: "result",
        },
        {
          title: "索要金额",
          align: "center",
          key: "amount",
        },
        {
          width: 170,
          title: "时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "状态",
          align: "center",
          slot: "status",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
        {
          title: "备注",
          align: "center",
          slot: "remark",
        },
      ],
      data: [],
      tableLoading: false,
      searchObj: {
        status: -1,
        page: 1,
        limit: 10,
        total: 0,
      },
      remark: "",
      pushRemarkModalVisibility: false,
      resultList: [],
      pushResultModalVisibility: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    onCheckDomainStatus(val) {
      this.searchObj.status = val;
      this.onPageChange(1);
    },
    // 请求
    async req_getList() {
      try {
        let params = {
          dn: this.searchObj.domainName,
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          type: 1,
        };
        if (this.searchObj.status !== -1) {
          params.status = this.searchObj.status;
        }
        this.tableLoading = true;
        const { code, data } = await pushPageList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list || [];
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.searchObj.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.domainName = "";
      this.searchObj.status = -1;
      this.onPageChange(1);
    },
    // 查看备注
    onShowRemark(val) {
      this.pushRemarkModalVisibility = true;
      this.remark = val;
    },
    // 拒绝
    onReject(val) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>您确认取消PUSH吗？</p>",
        onOk: async () => {
          try {
            const res = await pushEdit({
              id: val.id,
              status: 3,
            });
            if (res.code === 200) {
              this.$Message.success("操作成功!");
              this.req_getList();
            } else {
              this.$Message.warning("操作失败，稍后重试!");
            }
          } catch (error) {
            this.$Message.warning("操作失败，稍后重试!");
          }
        },
      });
    },
    // 查看域名
    onShowDomainList(val) {
      this.pushResultModalVisibility = true;
      this.resultList = val;
    },
  },
};
</script>

<style lang="less" scoped>
.bj-search-section{
    background-color: #28292C;
    padding: 30px 28px;
    border-radius: 6px;
    margin-top: 40px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
  .item-radio{
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    cursor: pointer;
    margin-right: 40px;
    border: 1px solid #fff;
    min-width: 100px;
    line-height: 40px;
    text-align: center;
    border-radius: 8px;
    transition: all .3s;
  }
  .item-radio.active {
    color: #fff;
    background-color: #F85A36;
  }
</style>
